@let isEditingParams =
  unassignedSponsoredAccountsEc.plugins.currentListPlugin.feature.selectors.isEditingParams.asSignal();
@let isEditingComment =
  unassignedSponsoredAccountsEc.plugins.currentEntityPlugin.feature.selectors
    .isEditing()
    .asSignal();

<div class="atn-space-report-usa">
  <div class="atn-space-report-usa__data">
    <atn-ds-table [config]="unassignedSponsoredAccountsTableConfig">
      <div
        class="atn-space-report-usa__actions"
        customTools
      >
        <i
          class="atn-icon atn-funnel atn-blue atn-space-report-usa__action-icon"
          [class.atn-space-report-usa__icon-with-info]="hasAppliedFiltersSg()"
          (click)="filtersClickHandler()"
        ></i>
      </div>
    </atn-ds-table>
  </div>

  @if (!isStandardUserSg()) {
    <atn-ds-widget title="Configuration">
      <div class="atn-space-report-usa__configuration">
        <atn-ds-checkbox
          label="Show Salary Information"
          [selected]="configurationSg().showSalaryInformation"
          (selectedChange)="showSalaryInformationChangeHandler($event)"
        />
      </div>
    </atn-ds-widget>
  }
</div>

@if (isEditingParams) {
  <atn-space-unassigned-sponsored-accounts-filters />
}

@if (isEditingComment) {
  <atn-space-unassigned-sponsored-comment-modal
    [collection]="unassignedSponsoredAccountsEc"
  />
}
